// extracted by mini-css-extract-plugin
export default {"heading":"Single_heading__qYycL","img-container":"Single_img-container__BRNvm","img":"Single_img__Npxnp"};